import React from "react";
import { Grid, IconButton, Tooltip } from "@mui/material"
import Typography from "component/commonComponents/Typography"
import { Done as DoneIcon } from "@mui/icons-material";
import { StyledDelegatedUser } from "./delegatedUserSelection.style";

export interface IDelegatedUserSelection {
  delegatedUsers: any,
  locale: any,
  onChange: (value?: any) => void,
  queryUserByUserName?: boolean,
}

const DelegatedUserSelection: React.FC<IDelegatedUserSelection> = (props) => {
  const { onChange, queryUserByUserName } = props;    

  const handleClick = (users: any, uid: string) => {
      const newUsers = users.filter((item: any) => {
          return item.uid !== uid
      })
      onChange(newUsers);
  };

  return (
    props.delegatedUsers ? (
      <StyledDelegatedUser container>
        {
          props.delegatedUsers.map((item: any) => (
            <Grid item xs={12} key={item.uid} container className="user-wrapper container">
              <Grid item xs={12}>
                <Typography
                  className="user-delegated"
                  kind="span"
                  as="h6"
                  fontWeight={700}
                >
                  {/* Delegated User:  */}
                  {props.locale?.delegatedUser}
                  <Tooltip title={queryUserByUserName? item.user_name : item.email}>
                  <span className="user-name" tabIndex={0} id="lbl-delegateduserselection-email">
                      {queryUserByUserName? item.user_name : item.email}
                  </span>
                  </Tooltip>
                </Typography>
              </Grid>
              <Grid item xs={2} className="user-status">
                <DoneIcon className="icon-success"/>
                <IconButton className="btn-remove" onClick={() => handleClick(props.delegatedUsers, item.uid)} aria-label="Remove User Button" id="btn-delegateduserselection-remove">
                    {/* Remove */}
                    {props.locale?.remove}
                </IconButton>
              </Grid>
            </Grid>
          ))
        }
      </StyledDelegatedUser>
    )
    : <></>
  )
}

export default DelegatedUserSelection;